package com.milta.core.localization.translations.nl

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Annuleren",
    confirm = "Bevestigen",
    save = "Opslaan",
    delete = "Verwijderen",
    back = "Terug",
    loading = "Laden…",
    retry = "Opnieuw proberen",
    language = "Taal",
    welcomeTitle = "Welkom bij Milta",
    welcomeSubtitle = "Uw slimme bezorgassistent",
    alreadyHaveAccount = "Ik heb al een account",
    createAccount = "Account aanmaken",
    continueWithGoogle = "Doorgaan met Google",
    continueWithApple = "Doorgaan met Apple",
    oauthErrorGeneric = "Er is iets misgegaan bij het inloggen. Probeer het opnieuw.",
    oauthAppleWebComingSoon = "Inloggen met Apple komt binnenkort beschikbaar op het web.",
    oauthDriverAccountNotAllowedOnWeb = "Chauffeursaccounts hebben geen toegang tot het webdashboard. Log in via de mobiele app.",
    oauthAccountNotFoundOnWeb = "Er is geen Milta-account gevonden voor dit Google-account.",
    errorOffline = "Geen internetverbinding.",
    navTourneesDuJour = "Ritten van vandaag",
    navAjouterUneTournee = "Rit toevoegen",
    navHistoriqueDesPreuves = "Bezorggeschiedenis",
    navParametres = "Instellingen",
    sidebarRoleManagerLabel = "Manager",
    noDeliveriesYetTitle = "Nog geen bezorgingen",
    noDeliveriesYetSubtitle = "Tik op \"Bezorgingen toevoegen\" om er toe te voegen",
    optimizationUnavailableExplanation = "Wilt u de rit zonder optimalisatie aanmaken, of het opnieuw proberen?",
    createWithoutOptimizationAction = "Aanmaken zonder optimalisatie",
    gpsAppSheetTitle = "Kies een navigatie-app",
    addressSearchingLabel = "Zoeken…",
)
